import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import useStyle from './style';
var ProCardActions = function ProCardActions(props) {
  var actions = props.actions,
    prefixCls = props.prefixCls;
  var _useStyle = useStyle(prefixCls),
    wrapSSR = _useStyle.wrapSSR,
    hashId = _useStyle.hashId;
  if (Array.isArray(actions) && (actions === null || actions === void 0 ? void 0 : actions.length)) {
    return wrapSSR(_jsx("ul", {
      className: classNames("".concat(prefixCls, "-actions"), hashId),
      children: actions.map(function (action, index) {
        return (
          // eslint-disable-next-line react/no-array-index-key
          _jsx("li", {
            style: {
              width: "".concat(100 / actions.length, "%")
            },
            children: _jsx("span", {
              children: action
            })
          }, "action-".concat(index))
        );
      })
    }));
  }
  return wrapSSR(_jsx("ul", {
    className: classNames("".concat(prefixCls, "-actions"), hashId),
    children: actions
  }));
};
export default ProCardActions;